import React, { useState, memo } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

const RowItemReject = (props) => {
  const [modalDelete, setModalDelete] = useState(false);

  const toggleModalDelete = async () => {
    await setModalDelete(!modalDelete);
  };
  const [reason, setReason] = useState('');

  const onConfirm = () => {
    setModalDelete(false);
    toggleModalDelete().then(() => {
      setTimeout(() => {
        props.onConfirm(reason);
      }, 300);
    });
  };

  const onChangeText = (e) => {
    setReason(e.target.value);
  };

  return (
    <>
      <button className="btn btn-sm btn-danger m-r-2" onClick={toggleModalDelete}>
        <i className="fa fa-ban"></i>
      </button>
      <SweetAlert
        title={<span className="text-black text-wrap">Are you sure you want to cancel it?</span>}
        danger
        showCancel
        confirmBtnText="Yes, cancel it!"
        confirmBtnBsStyle="danger"
        onConfirm={onConfirm}
        focusCancelBtn={false}
        focusConfirmBtn={false}
        onCancel={toggleModalDelete}
        show={modalDelete}
        dependencies={[reason]}
      >
        <form>
          <textarea
            type="text"
            className="form-control"
            value={reason}
            onChange={onChangeText}
            placeholder="Please indicate the reason for cancelling"
          />
        </form>
      </SweetAlert>
    </>
  );
};

export default memo(RowItemReject);
